import React from 'react';
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render(){
        const accountId = this.props.match.params.account_id;
        const ipData = {
            url: `/admin/clients/accounts/${accountId}/aliases`,
            filter: {ATRAUTHTYID: '1'},
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRACCTID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'IP Address',
                        source: 'ATRIPADDR',
                        type: 'text',
                        editable: true,
                        visible: true
                    },
                    {
                        label: 'Product',
                        source: 'ATRPRODUCTID',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: {
                            type: 'metadata',
                            data: 'ATRPRODUCTID'
                        }
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'checkbox',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label: 'Location',
                        source: 'ATRLOCATIONPROFILEID',
                        type: 'select',
                        editable: true,
                        visible: true
                    },
                    {
                        label: 'Caller ID Type',
                        source: 'ATRCALLERIDTYPE',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: 'fixed'
                    },
                    {
                        label: 'Caller ID',
                        source: 'ATRCALLERID',
                        type: 'text',
                        editable: true,
                        visible: true
                    },
                    {
                        label : 'Actions',
                        type: 'action_buttons'
                    },
                    {
                        label: '',
                        source: 'ATRAUTHTYID',
                        type: 'text',
                        visible: false,
                        default : 1
                    }
                ]
        }
        const regData = {
            url: `/admin/clients/accounts/${accountId}/aliases`,
            filter: {ATRAUTHTYID: '2'},
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRACCTID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Username (ID)',
                        source: 'ATRALIAS',
                        type: 'text',
                        editable: true,
                        visible: true
                    },
                    {
                        label: 'Password',
                        source: 'ATRPASSW',
                        type: 'password',
                        default: 'RANDOM',
                        pattern: '[0-9a-zA-Z_]{16}',
                        editable: true,
                        visible: true
                    },
                    {
                        label: 'Product',
                        source: 'ATRPRODUCTID',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: {
                            type: 'metadata',
                            data: 'ATRPRODUCTID'
                        }
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'checkbox',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label: 'Location',
                        source: 'ATRLOCATIONPROFILEID',
                        type: 'select',
                        editable: true,
                        visible: true
                    },
                    {
                        label: 'Caller ID Type',
                        source: 'ATRCALLERIDTYPE',
                        type: 'select',
                        editable: true,
                        visible: true,
                        default: 'fixed'
                    },
                    {
                        label: 'Caller ID',
                        source: 'ATRCALLERID',
                        type: 'text',
                        editable: true,
                        visible: true
                    },
                    {
                        label : 'Actions',
                        type: 'action_buttons'
                    },
                    {
                        label: '',
                        source: 'ATRAUTHTYID',
                        type: 'text',
                        visible: false,
                        default : 2
                    }
                ]
        }
        return (
            <div>
                <Panel title = "IP Based Accounts">
                <Resource
                    addButtonText = "Add Account"                    
                    data = {ipData}
                    {...this.props} 
                />
                </Panel>
                <Panel title = "Registered Accounts">
                    <Resource
                        addButtonText = "Add Account"                    
                        data = {regData}
                        {...this.props} 
                    />
                </Panel>
            </div>
        )
    }
}
